"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var selectInlinePreviewsOption_1 = require("../actions/selectInlinePreviewsOption");
var store_1 = require("../store/store");
var owa_options_core_1 = require("owa-options-core");
var ChoiceGroup_1 = require("office-ui-fabric-react/lib/ChoiceGroup");
var owa_session_store_1 = require("owa-session-store");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var InlinePreviewsFull = /** @class */ (function (_super) {
    tslib_1.__extends(InlinePreviewsFull, _super);
    function InlinePreviewsFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (ev, option) {
            selectInlinePreviewsOption_1.default(option.key === 'true');
        };
        return _this;
    }
    InlinePreviewsFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var isPreviewsInlineEnabled = owa_options_core_1.getFallbackValueIfNull(optionStore.isEnabled, userOptions.ShowInlinePreviews);
        return (React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: "" + isPreviewsInlineEnabled, options: [
                {
                    key: 'true',
                    text: owa_options_strings_1.default.options_inlinePreviews_enabled,
                },
                {
                    key: 'false',
                    text: owa_options_strings_1.default.options_inlinePreviews_disabled,
                },
            ], onChange: this.onChange }));
    };
    InlinePreviewsFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
        })
    ], InlinePreviewsFull);
    return InlinePreviewsFull;
}(React.Component));
exports.default = InlinePreviewsFull;
//# sourceMappingURL=InlinePreviewsFull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inline-previews-option/lib/components/InlinePreviewsFull.js
// module id = 5094
// module chunks = 2